<template>

  <div class="">
    <b-card
      overlay
      :img-src="imgUrl"
      img-alt="Login V2"
      text-variant="white"
    >
      <b-row class="overflow">
        <b-col lg="4" class="">
          <b-card class="h-100 auth-bg m-0">
            <div class="text-center">
              <Logo class="w-75 h-75" />
            </div>

            <b-card-text class="mb-2 text-dark">
              Please sign-in to your account
            </b-card-text>

            <b-alert variant="warning" show v-if="false">
              <div class="alert-body font-small-2">
                <p>
                  <small class="mr-50"><span class="font-weight-bold">Usuario:</span> userdemo@mail.com</small>
                </p>
                <p>
                  <small class="mr-50"><span class="font-weight-bold">Contraseña:</span> passwordDemo </small>
                </p>
              </div>
              <feather-icon v-b-tooltip.hover.left="'Esto es solo para propositos de prueba'" icon="HelpCircleIcon"
                size="18" class="position-absolute" style="top: 10; right: 10;" />
            </b-alert>

            <!-- form -->
            <div class="mb-auto">
              <Login />
            </div>

            <b-row class="mt-auto">
              <b-col lg="12" class="d-lg-flex align-items-center pt-5 ">
                <div class="w-100  text-center phoneContent">
                  <h4>We're here</h4>
                  <div>
                    <hr>
                    <!-- <span class="icons phoneAds"><font-awesome-icon icon="fa-solid fa-phone" /></span> -->
                  </div>
                </div>
              </b-col>
              <b-col lg="6" class="d-lg-flex align-items-center pt-1 ">
                <div class="w-100  text-center phoneContent">
                  <h6>Call Center</h6>
                  <div class="ulClass">
                    <ul class="text-left">
                      <li>
                        <a href="tel:+529842420151" target="_blank">+52 984 242 0151</a>
                      </li>
                    </ul>
                  </div>

                  <h6>WhatsApp</h6>
                  <div class="ulClass">
                    <ul class="text-left">
                      <li>
                        <a href="https://wa.me/16198153397" target="_blank">+1 619 815 3397</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-col>
              <b-col lg="6" class="d-lg-flex align-items-center pt-1 ">
                <div class="w-100  text-center phoneContent">
                  <h6>Toll Free</h6>
                  <div class=" ulClass pl-1">
                    <ul class="text-left">
                      <li>
                        <span class="text-dark">From Mexico:</span> <br>
                        <a href="tel:8006811588" target="_blank">800 681 1588 </a>
                      </li>
                      <li>
                        <span class="text-dark">USA &amp; Canada:</span> <br>
                        <a href="tel:18668653664" target="_blank">1 (866) 865-3664</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>

</template>

<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'
import Logo from '@/modules/layouts/components/Logo.vue'
import Login from '@/modules/auth/components/Login'
import store from '@/store/index'

export default {
  components: {
    Logo,
    Login
  },
  data() {
    return {
      sideImg: require('@/assets/images/pages/owners-login.jpg'),
    }
  },
  computed: {
    ...mapState('appConfig', ['windowWidth']),

    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/owners-login.jpg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';
@media screen and (max-width: 767px) {
  .auth-wrapper.auth-v2 .brand-logo {
    position: relative;
    left: 0;
    margin: 0 auto;
  }

  .auth-wrapper .brand-logo {
    display: flex;
    justify-content: center;
    // flex-direction: column;
  }

}

@media screen and (max-width: 991px) {
  .main-image{
    display: none;
  }
}


.brand-logo svg {
  height: 125px;
  width: 250px;
}

span.icons.phoneAds {
  position: absolute;
  top: 27px;
  background: #fff;
  padding: 0 3px 0px 4px;
}

.phoneContent {
  position: relative;
}



.ulClass {
  display: inline-block;
}

.ulClass ul {
  padding: 0 0 0 9px;
  font-size: 12px;
}

.ulClass a:hover {
  /* display: inline-block; */
  opacity: 0.6;
}

.bg-login{
  background-image: url('~@/assets/images/pages/owners-login.jpg') !important;
}

.card-img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.auth-bg{
  background-color: #ffffffc2 !important;
}

.overflow{
  height: 100%;
  overflow-x: auto;
}
</style>
